import React, { useState } from 'react';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';

export interface LoginFormProps {
  onSubmit: (username: string, password: string) => Promise<void>;
  isLoading?: boolean;
  error?: string;
}

export const LoginForm = ({
  onSubmit,
  isLoading = false,
  error,
}: LoginFormProps) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');

    if (!username || !password) {
      setFormError('Kullanıcı adı ve şifre gereklidir');
      return;
    }

    try {
      await onSubmit(username, password);
    } catch (err) {
      setFormError(err instanceof Error ? err.message : 'Giriş başarısız');
    }
  };

  const displayError = error || formError;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Kullanıcı Adı"
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Kullanıcı adınızı girin"
        disabled={isLoading}
        required
      />
      <Input
        label="Şifre"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Şifrenizi girin"
        disabled={isLoading}
        required
      />
      {displayError && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{displayError}</p>
        </div>
      )}
      <Button
        type="submit"
        variant="primary"
        size="large"
        isLoading={isLoading}
        className="w-full"
      >
        Giriş Yap
      </Button>
    </form>
  );
};

